module.exports = __webpack_public_path__ + "img/0Q3B5808_9-HDR_BlackMatted_MockedUp.fe1b84f5.jpg";